const IconExpand = ({ className = '', color = 'white', ...rest }) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="79"
    height="78"
    fill="none"
    viewBox="0 0 79 78"
    className={className}
    {...rest}
  >
    <path
      fill="url(#pattern0_103_1088)"
      d="M.977.545h77.046v77.046H.977z"
    ></path>
    <defs>
      <pattern
        id="pattern0_103_1088"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_103_1088" transform="scale(.01111)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACo0lEQVR4nO2cX0sbQRTFVwtai5+8FLX+IcmL7Wfog+QbVahNgxLz5pGhg4gkm92ZM5t7Z88PfJPMub/sJmHn3mkaIYQQQgghhBBCiBED4DOA7wD+II9/AK4BnAyQ+QuAGwDLzMwPsfbimZu4EJPpAJmn5MznzQChF+TQKwCHBfMeAngmZ34olfd98Bdy6JVD0S+l8r4Pzmbi8KMDnkQvAFwO9GV4AuAqfgFTsCR6Hn6hNE4AcATgl0fRbmSjp2SLos3LRoJkq6LNyk6VHBgi3DbudmS7A3DcGCFk6ZjZnOguV8fcwpXdJ6s50X0LaPZE34wmRacUMiQp2cyKTi2oNKmZTIvOKawEOVnMi84tkEVuBhei9y0bhLX3KXrTg5kF6TfrMTEnZc2UelkFhO2nj1ySCr8g5rxivLGp9bIeOU7jA/vwN+n6qBO7ZT8BOCA97F/lSs6tl0IQkiIF7bLXjN2WKHqdK5lR717Bdtm3xDV+sCS7Bv9lX8SPi3D13QI4Jb7+aZS9jmucj07ykLeku9tdCCGEEEIIIYQQQgghhBBi11bWNwB/4+7yjLm7HHevZ/G1w8Tr19FtZWH75uyMuMasis3Z1LYAtLcbPBL3IZ/I7QbFhk7bbsnrOMC+jB1BrAaaJTHnI7GBJqne3AJCi8BHzkgtYWfEnKG9gNESllQvo4D7DQv/rrjJ8b5vvawCNtLy/0dq200L33lhNaJn0HVhC5KrH62wJLnaYSGLkqsbf7MsuZqBTg+SqxhR1tA9GaQxt3Al13KMhCvJtR2MYlpyLUf9uJBcy+FVtZ1N+obHAwanA2T2dcBg3Llgs3J4ZCaKTnsB+NQykTom0c/Ft7YA/CSHnjj86KBN+HadSB3b2aRr9oSvEEIIIYQQQgghROOQV2N4g190TSi3AAAAAElFTkSuQmCC"
        id="image0_103_1088"
        width="90"
        height="90"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
);

export default IconExpand;